<template>
    <div class="grid sm:grid-cols-2 gap-4 pb-28 pt-5">
        <MissionItem
                v-for="(mission) in missionList"
                :key="mission.partitionKey"
                :mission="mission"
        ></MissionItem>

        <div v-if="!missionList">
            Not Found
        </div>
    </div>
</template>
<script>
//component
import MissionItem from "./MissionItem.vue";
//service
// import BzbsCampaign from "@/core/Campaign/service/BzbsCampaign.js";

import ConfigManager from "@/config/ConfigManager.js";
/**
 * @event onLoaded
 */
export default {
    name: "CampaignList",
    components: {
        MissionItem,
    },
    props: {
        missionList:        { type: [Array,Object], required: true },
    },
    data: function() {
        return {
            listConfig: null,
            filterConfig: null,

            campaigns: [],

            isLoading: false,
            isLoaded: false,
            isHaveItem: false,
        };
    },
    created: function() {

    },
    methods: {
        getCampaignImage: function (key) {
            return ConfigManager.getBlobUrl() + "/webconfig/tipcoin/images/badge/" + key + ".png";
        },
    },
}
</script>
<style lang="scss" scoped>
</style>
